<wiz-vgroup #vgDetailZone width="100%" height="100%" horizontalAlign="center" gap="2" padding="5px" class="section-container">
  <wiz-hgroup width="100%" verticalAlign="center" padding="3px">
    <wiz-label #lbTitle width="100%" class="smallTitleLabel"></wiz-label>
    <wiz-icon class="image-purple" (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>


  <!-- gestion du styles des headers de grid -->
  <wiz-vgroup #gpHeader visible="true" verticalAlign="center" width="100%" class="section-container" padding="5px" gap="0">
    <wiz-label [wizLabel]="'$.pivot.edit.header.title.$'" class="smallTitleLabel"></wiz-label>
    <wiz-hgroup width="100%">
      <wiz-dropdown #ddGrp width="200px" visible="true" [wizLabelField]="'groupLabel'" [wizLabel]="'$.pivot.edit.field.group.parent.$'"></wiz-dropdown>
      <wiz-text-input #tiLabel width="200px" [wizLabel]="'$.common.label.$'" [wizMaxChars]="50"> </wiz-text-input>
      <wiz-dropdown #ddHeaderAlign width="120px" 
        visible="true" 
        [wizLabelField]="'trsLabel'" 
        [wizLabel]="'$.common.text.align.$'"></wiz-dropdown>
    </wiz-hgroup>
    <wiz-hgroup width="100%">
      <wiz-hgroup #headerColors visible="true" width="100%" >
        <wiz-vgroup width="150px">
          <wiz-label wizLabel="$.style.css.fontcolor.$" style="font-size: 11px"></wiz-label>
          <wiz-hgroup>
            <span
              #blockFont
              [style.backgroundColor]="fontColor"
              style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
              width="20px"
              height="20px"
              (click)="showColorPicker($event)"
            ></span>
            <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('blockFont')">removal</wiz-icon>
          </wiz-hgroup>
        </wiz-vgroup>
        <wiz-vgroup width="150px">
          <wiz-label wizLabel="$.style.css.backgroundcolor.$" style="font-size: 11px"></wiz-label>
          <wiz-hgroup>
            <span
              #blockBack
              [style.backgroundColor]="backgroundColor"
              width="20px"
              height="20px"
              (click)="showColorPicker($event)"
              style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
            ></span>
            <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('blockBack')">removal</wiz-icon>
          </wiz-hgroup>
        </wiz-vgroup>
      </wiz-hgroup>
    </wiz-hgroup>
  </wiz-vgroup>

  <wiz-spacer height="100%"></wiz-spacer>
  <wiz-hgroup width="100%" height="45px" padding="5px" horizontalAlign="end">
    <wiz-button
      #btnSave
      [wizLabel]="'$.common.save.modification.$'"
      [wizIcon]="'icon-arrow-right'"
      (click)="save()"
      [iconPlacement]="'right'"
    ></wiz-button>
    <wiz-button
      #btnCancel
      class="cancel-button"
      [wizIcon]="'icon-arrow-left'"
      (click)="doCancel()"
      [wizLabel]="'$.common.cancel.modification.$'"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
